import BulkActionButtons from './component';
import { BulkActionButtonProps } from './types';

export default BulkActionButtons;
export type { BulkActionButtonProps };
